const x = document.querySelector(".klaviyo-bis-trigger-fake");

if(x) {
  x.addEventListener("click", function() {
    document.querySelector(".klaviyo-bis-trigger")?.click();
  })
}

if (!window.customElements.get('sticky-button')) {
  class StickyButton extends HTMLElement {
    constructor() {
      super();

      this.deviceType = this.dataset.deviceType;
      this.connectedElementSelector = this.dataset.connectedElement;
      this.hiddenOnElementsSelectors = ['.ProductGallery','.Product__Block--buyButtons'];

      this.observer = null;

      this._setBannerVisibility = this.setBannerVisibility.bind(this);
    }

    get connectedElement() {
      return document.querySelector(this.connectedElementSelector) || null;
    }

    get hiddenOnElements() {
      return document.querySelectorAll(this.hiddenOnElementsSelectors);
    }

    connectedCallback() {
      this.init();
      this.createIntersectionObserver();
      this.observeHiddenElements();
    }

    disconnectedCallback() {
      this.destroy();
      this.observer?.disconnect();
    }

    init() {
      if (!this.connectedElement) return;

      this.setBannerVisibility();
      window.addEventListener('scroll', this._setBannerVisibility)
    }

    destroy() {
      window.removeEventListener('scroll', this._setBannerVisibility)

      this.classList.add('sticky-cta-banner--hidden');
    }

    validateDeviceType() {
      switch (this.deviceType) {
        case 'mobile':
          return window.innerWidth < 1007

        case 'desktop':
          return window.innerWidth >= 1008 
          
        case 'both':
          return true;
      }
    }

    createIntersectionObserver() {
      if (!this.hiddenOnElements?.length) return;

      const options = { threshold: 1 };
      const onEntry = (entries) => {
        entries.forEach(entry => {
          this.classList.toggle('sticky-button--hidden-on-element', entry.isIntersecting);
        });
      };

      this.observer = new IntersectionObserver(onEntry, options);
    }

    observeHiddenElements() {
      if (!this.observer) return;

      this.hiddenOnElements.forEach((element) => {
        this.observer.observe(element)
      })
    }

    setBannerVisibility() {
      const { top: connectedElementScrollPosition } = this.connectedElement?.getBoundingClientRect() || null;
      if (connectedElementScrollPosition === null) return;

      if (!this.validateDeviceType()) {
        this.classList.add('sticky-button--hidden');
        return;
      }

      console.log(connectedElementScrollPosition);

      this.classList.toggle('sticky-button--hidden', connectedElementScrollPosition > 0);
    }
  }

  window.customElements.define('sticky-button', StickyButton)
}
